const categoriesFormatter = (res) => {
  const data = res?.data;

  return data;
};

export default categoriesFormatter;
